<script setup lang="ts">
import {defineAsyncComponent, inject, ref} from 'vue';
import {useWindowScroll, computedEager} from '@vueuse/core';

import {viewportSize} from '@teemill/common/helpers';
import {AppHeader} from '@teemill/modules/app';

import StoreFrontNestedMenu from './StoreFrontNestedMenu.vue';
import StoreFrontHeaderIcons from './StoreFrontHeaderIcons.vue';
import {computed} from 'vue';
import {Theme} from '@teemill/common/classes';
const StoreFrontHeaderSearchBar = defineAsyncComponent(
  () => import('./StoreFrontHeaderSearchBar.vue')
);

const theme = inject<() => Theme | undefined>('theme', () => undefined);

defineProps<{
  noClickStyles: {pointerEvents: string | undefined};
}>();

const {y: scrollY} = useWindowScroll();

const shouldShowSearchBar = computed(
  () => theme()?.get('menu.searchBar.show') === '1'
);

const logoHeight = computedEager(() => {
  if (viewportSize.isSmaller('md')) {
    return '2.5rem';
  }

  if (scrollY.value === 0 && !shouldShowSearchBar.value) {
    return '4rem';
  }

  return '3rem';
});
</script>

<template>
  <app-header :style="{...noClickStyles}">
    <template #logo>
      <tml-anchor
        href="/"
        class="flex items-center h-full w-full"
        :class="{
          'py-2': !shouldShowSearchBar,
          'py-[10px]': shouldShowSearchBar,
        }"
      >
        <tml-logo :height="`Min(${logoHeight}, 100%)`" header-align />
      </tml-anchor>
    </template>
    <template #content>
      <template v-if="shouldShowSearchBar">
        <div class="grow flex items-center justify-between">
          <div
            v-if="viewportSize.isGreater('md')"
            ref="searchBarContainer"
            class="mr-auto mt-3 w-full ml-auto"
          >
            <store-front-header-search-bar />
          </div>

          <store-front-header-icons
            class="ml-auto"
            :excluded="viewportSize.isSmaller('md') ? [] : ['search']"
          />
        </div>
      </template>
      <template v-else>
        <div v-if="viewportSize.isGreater('md')" class="ml-4">
          <store-front-nested-menu class="ml-4" direction="row" />
        </div>
        <div class="grow flex items-center justify-end">
          <store-front-header-icons
            :excluded="shouldShowSearchBar ? ['search'] : []"
          />
        </div>
      </template>
    </template>
    <template v-if="shouldShowSearchBar" #subContent>
      <store-front-nested-menu
        v-if="viewportSize.isGreater('md')"
        direction="row"
        class="pb-3 pt-2 px-4"
      />
    </template>
  </app-header>
</template>
